import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../../reducers";
import {getStoreDefaultConfig} from "../../../services/Store/reducer";
import {Offcanvas} from "react-bootstrap";
import {ConfigApi} from "../../../services/Api/types";
import FooterSocialMedia from "../../layout/Footer/components/FooterSocialMedia";
import StringHelper from "../../../services/Common/StringHelper";
import {getUser} from "../../../services/User/reducer";
import {selectLocale} from "../../../services/Session/reducer";
import UserUtils from "../../../services/User/UserUtils";
import AppConfig from "../../../services/AppConfig";
import StoreUtils from "../../../services/Store/StoreUtils";
import DrawerLanguages from "../DrawerLanguages";
import {getLanguagesBasedOnStoreType} from "../../../services/languageUtils";
import DrawerUserSection from "./DrawerUserSection";
import DrawerStoreSection from "./DrawerStoreSection";
import DrawerLinksSection from "./DrawerLinksSection";
import DrawerMultiStoreSection from "./DrawerMultiStoreSection";
import IframeWidget from "../../../utils/IframeWidget";

interface OwnProps {
    show: boolean,
    onHide: () => void,
    config: ConfigApi
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function Drawer(props: Props) {
    const {t} = useTranslation();
    const addressFullString = props.config ? StringHelper.getAddressName(props.config.address) : undefined;
    const menuLinks = props.config?.layout.links ? [...props.config?.layout.links].filter(x => x.type === "MENU").sort((a, b) => a.position - b.position || a.title.localeCompare(b.title)) : undefined;

    return (
        <Offcanvas placement={"end"} show={props.show} onHide={() => IframeWidget.onHide(props.onHide)}
                   className='drawer'
                   onShow={() => IframeWidget.onShow()}>
            <Offcanvas.Header closeButton aria-label={t("common.action.close")}>
                <Offcanvas.Title>
                    {props.config?.layout.image_link ? (
                        <img alt={t("common.word.location_logo")} src={props.config?.layout.image_link.default}/>
                    ) : (
                        props.config?.name
                    )}
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {(AppConfig.isMultistore() && !StoreUtils.isMultistore(props.config)) && (
                    <DrawerMultiStoreSection addressFullString={addressFullString}/>
                )}
                {UserUtils.isLoyaltyRegistration(props.default_config?.loyalty) && <DrawerUserSection/>}
                {(!StoreUtils.isMultistore(props.config)) && (
                    <DrawerStoreSection config={props.config} addressFullString={addressFullString}/>
                )}
                {(menuLinks && menuLinks.length > 0) && (
                    <DrawerLinksSection menuLinks={menuLinks}/>
                )}
                <DrawerLanguages languages={getLanguagesBasedOnStoreType(props.default_config)} locale={props.locale}
                                 onHideDrawer={props.onHide}/>
                <FooterSocialMedia/>
            </Offcanvas.Body>
        </Offcanvas>
    )
}


const mapStateToProps = (state: RootState) => ({
    locale: selectLocale(state.session),
    user: getUser(state.user),
    default_config: getStoreDefaultConfig(state.config)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(Drawer));